export const baseUrl = "https://gaswale.vensframe.com/api/admin/";
// export const baseUrl = "https://gaswale.com/api/admin/";

// Format currency
export const formatCurrency = (amount) => {
  if (!amount) return "₹ 0";
  return `₹ ${parseFloat(amount).toLocaleString("en-IN")}`;
};

// Enhanced Indian price formatting function
export const formatIndianPrice = (amount, showDecimals = "auto") => {
  if (!amount && amount !== 0) return "₹ 0";

  let formatOptions = {};

  if (showDecimals === "always") {
    // Always show 2 decimal places: 123.00
    formatOptions = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
  } else if (showDecimals === "never") {
    // Never show decimals: 123
    formatOptions = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    };
  } else {
    // Auto mode - show decimals only if needed: 123.5 or 123
    formatOptions = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    };
  }

  const formattedAmount = Number(amount).toLocaleString("en-IN", formatOptions);
  return `₹ ${formattedAmount}`;
};

// More comprehensive function with all options
export const formatPrice = (amount, options = {}) => {
  const {
    currency = "₹",
    decimals = "auto", // 'auto', 'always', 'never'
    minimumDecimals = 0,
    maximumDecimals = 2,
  } = options;

  if (!amount && amount !== 0) return `${currency} 0`;

  let formatOptions = {};

  switch (decimals) {
    case "always":
      formatOptions = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      break;
    case "never":
      formatOptions = {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      };
      break;
    default: // 'auto'
      formatOptions = {
        minimumFractionDigits: minimumDecimals,
        maximumFractionDigits: maximumDecimals,
      };
  }

  const formattedAmount = amount.toLocaleString("en-IN", formatOptions);
  return `${currency} ${formattedAmount}`;
};
